import type { HeadingProps } from '@chakra-ui/react';

export const getDecimalsStyles = (size: HeadingProps['size']) => {
  if (size === 'h2') {
    return { '.decimal': { fontSize: 'sm', fontWeight: 'normal' } };
  }

  if (size === 'h3' || size === 'h5' || size === 'body2') {
    return { '.decimal': { fontSize: '2xs', fontWeight: 'medium' } };
  }

  if (size === 'title2') {
    return {
      '.decimal': {
        fontFamily: 'sans',
        fontSize: '2xs',
      },
    };
  }

  return {};
};
